import { zodInvoiceStopperRuleSchema } from '../useQueryInvoiceStopperRules';

export { zodInvoiceStopperRuleSchema } from '../useQueryInvoiceStopperRules';

export const zodUpdateStopperRuleSchema = zodInvoiceStopperRuleSchema.omit({
  buyerCompanyAccountName: true,
  buyerCompanyName: true,
  createdOn: true,
  id: true,
  modifiedOn: true,
  sellerCompanyAccountName: true,
  sellerCompanyName: true,
});
